module.exports = __webpack_public_path__ + "static/media/robot-green-happy.b5177db1.svg";